<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.1875 2.75C5.9711 2.75 5.76734 2.85189 5.6375 3.025L1.5125 8.525C1.32322 8.77738 1.32999 9.12619 1.52892 9.37104L10.4664 20.371C10.597 20.5318 10.793 20.625 11 20.625C11.207 20.625 11.403 20.5318 11.5336 20.371L20.4711 9.37104C20.67 9.12619 20.6768 8.77738 20.4875 8.525L16.3625 3.025C16.2327 2.85189 16.0289 2.75 15.8125 2.75H6.1875ZM3.4375 8.25L6.53125 4.125H8.00234L6.71327 8.25H3.4375ZM8.15385 8.25L9.44291 4.125H12.5571L13.8461 8.25H8.15385ZM13.7969 9.625L11 17.2529L8.2031 9.625H13.7969ZM12.6036 16.8737L15.2614 9.625H18.4931L12.6036 16.8737ZM15.2867 8.25L13.9976 4.125H15.4688L18.5625 8.25H15.2867ZM3.50692 9.625H6.73857L9.39639 16.8736L3.50692 9.625Z" :fill="fill"/>
    </svg>
</template>

<script>
export default {
    name: "MyPlanIcon",
    props: ["fill"]
}
</script>
